<!--
 * @Author: 江舟
 * @Date: 2023-04-13 10:48:39
 * @LastEditors: 江舟
 * @LastEditTime: 2023-04-25 16:33:25
 * @FilePath: \Gov-Web\Mobile\src\pages\index\components\IndexToDo\complain\ComplainItem.vue
 * @Description: file content
-->
<template>
  <div class="card">
    <div class="card-title">
      <span v-if="data.type === 'deal'" class="card-tag card-tag__yellow">
        投诉
      </span>
      <span v-if="data.type === 'case'" class="card-tag card-tag__blue">
        诉转案
      </span>
      <span class="card-title__name">
        {{ data.statueName }}
      </span>
    </div>
    <div class="card-text">
      {{ data.defendantName }}：{{ data.defendantValue }}
    </div>
    <div class="card-text">
      {{ data.timeName }}：{{ data.time }}
    </div>
    <van-divider hairline style="margin-top: 4px; margin-bottom: 8px;"></van-divider>
    <div class="card-bottom">
      <div class="card-bottom__timeout">
        <template v-if="(data.handleTime || 0) < 0 && data.type !== 'case'">
          <van-icon :name="icons.icTimeRed" class="card-bottom__ic"></van-icon>
          <div class="card-bottom__time red">
            已超时{{ handleTimeStr }}
          </div>
        </template>
        <template v-else-if="data.handleTime && data.type !== 'case'">
          <van-icon :name="icons.icTimeGreen" class="card-bottom__ic"></van-icon>
          <div class="card-bottom__time green">
            {{ data.type === 'accept' ? '剩余响应时长' : (data.type === 'deal' ? '剩余办结时长' : '剩余时长') }}{{ handleTimeStr }}
          </div>
        </template>
      </div>
      <van-button color="#36B374" type="primary" class="card-button" @click="handleToDetail">
        立即处理
      </van-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { handleToComplainDetail } from '../../../../../utils/helper'
import { Divider } from 'vant'
export default {
  name: 'ComplainItem',
  components: {
    'van-divider': Divider
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      icons: {
        icTimeRed: require('../../../../../assets/common/ic-time-red.png'),
        icTimeGreen: require('../../../../../assets/common/ic-time-green.png')
      }
    }
  },
  computed: {
    handleTimeStr () {
      if (!this.data.handleTime) {
        return ''
      }
      let str = ''
      const seconds = Math.abs(this.data.handleTime)
      const day = parseInt((seconds / 60 / 60) / 24)
      const hour = parseInt((seconds / 60 / 60 ) % 24)
      const minute = parseInt((seconds / 60) % 60 )
      str =  `${day ? `${day}天` : ''}${hour ? `${hour}时` : ''}${minute ? `${minute}分` : ''}`
      if (!str) {
        const second = parseInt(seconds % 60 )
        str = second ? `${second}秒` : ''
      }
      return str
    }

  },
  methods: {
    handleToDetail () {
      handleToComplainDetail({
        isSupervise: !!this.data.superviseNumber,
        title: this.data.title,
        id: this.data.id,
        mainComplainNumber: this.data.mainComplainNumber,
        complainNumber: this.data.complainNumber,
        subId: this.data.subId,
        superviseNumber: this.data.superviseNumber,
      })
    }
  }
}
</script>

<style lang="less" scoped>
.card {
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 18px;
  padding: 12px;
  border: 1px solid #F2F5FA;

  &-title {
    &__name {
      font-size: 16px;
      font-weight: bold;
      line-height: 22px;
    }
  }

  &-tag {
    color: #fff;
    padding: 0 4px;
    height: 20px;
    font-size: 12px;
    border-radius: 2px;
    line-height: 20px;
    margin-right: 2px;
    position: relative;
    top: -2px;
    display: inline-block;

    &__yellow {
      background-color: #F4B473;
    }

    &__blue {
      background-color: #6EB3FB;
    }
  }

  &-text {
    color: #71747A;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 4px;
  }

  &-bottom {
    display: flex;
    justify-content: space-between;

    &__timeout {
      display: flex;
      align-items: center;
    }

    &__time {
      font-size: 12px;
      line-height: 14px;

      &.red {
        color: #FC523F;
      }

      &.green {
        color: #229F60;
      }
    }

    &__ic {
      font-size: 14px !important;
      margin-right: 3px;
    }
  }

  &-button {
    border-radius: 4px !important;
    line-height: 28px !important;
    font-size: 14px !important;
    padding: 0 8px !important;
    height: 28px !important;
  }
}</style>